import { useInt } from 'hooks/useInt';

import { Flag } from 'ui/atoms/Flag/Flag';

import styles from './LegalRegistryMarquee.module.scss';

type Registry = {
  code: string;
  name: string;
};

const REGISTRIES: Registry[] = [
  { code: 'gb', name: 'Companies House' },
  { code: 'us', name: 'Delaware Division of Corporations' },
  { code: 'de', name: 'Handelsregister' },
  { code: 'fr', name: 'Registre National des Entreprises' },
  { code: 'nl', name: 'KvK Handelsregister' },
  { code: 'es', name: 'Registro Mercantil' },
  { code: 'it', name: 'Registro Imprese' },
  { code: 'ie', name: 'Companies Registration Office' },
  { code: 'lu', name: 'RCS Luxembourg' },
  { code: 'ch', name: 'Zefix' },
  { code: 'se', name: 'Bolagsverket' },
  { code: 'no', name: 'Brønnøysundregistrene' },
  { code: 'dk', name: 'CVR' },
  { code: 'fi', name: 'Patentti- ja rekisterihallitus' },
  { code: 'pl', name: 'Krajowy Rejestr Sądowy' },
  { code: 'at', name: 'Firmenbuch' },
  { code: 'be', name: 'Kruispuntbank van Ondernemingen' },
  { code: 'pt', name: 'Registo Comercial' },
  { code: 'cz', name: 'Obchodní rejstřík' },
  { code: 'ro', name: 'ONRC' },
  { code: 'sg', name: 'ACRA' },
  { code: 'au', name: 'ASIC' },
  { code: 'nz', name: 'NZ Companies Office' },
  { code: 'ca', name: 'Corporations Canada' },
  { code: 'jp', name: 'National Tax Agency' },
  { code: 'in', name: 'Ministry of Corporate Affairs' },
  { code: 'hk', name: 'Companies Registry' },
  { code: 'ae', name: 'DMCC Registry' },
  { code: 'za', name: 'CIPC' },
  { code: 'br', name: 'Receita Federal CNPJ' },
  { code: 'mx', name: 'Registro Público de Comercio' },
];

const TRACK = [...REGISTRIES, ...REGISTRIES];

export const LegalRegistryMarquee = () => {
  const { t } = useInt();

  return (
    <div className={styles.root} role="region" aria-label={t('Primary registry sources')}>
      <span className={styles.label}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <circle cx="12" cy="12" r="8.5" />
          <path d="M3.5 12h17M12 3.5c2.6 2.3 4 5.3 4 8.5s-1.4 6.2-4 8.5c-2.6-2.3-4-5.3-4-8.5s1.4-6.2 4-8.5z" />
        </svg>
        {t('Primary registry sources')}
      </span>
      <div className={styles.mask}>
        <div className={styles.track}>
          {TRACK.map((registry, i) => (
            <span className={styles.item} key={`${registry.code}-${i}`}>
              <Flag code={registry.code} className={styles.flag} rounded />
              {registry.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
